import "./textTile.html";
import { BaseComponent } from "../../Core/BaseComponent";
import * as angular from "angular";
import { Binding } from "../../Utils/AngularBindings";
import "./textTile.less";
import "./textTile.controller";
export class TextTileComponent extends BaseComponent {
  constructor() {
    super(
      "Rhinestone.TextTileController",
      "/templates/tiles/textTile/textTile.html"
    );
    this.bindings = {
      tile: Binding.oneWay
    };
  }
}

angular.module("PortalApp").component("rhTextTile", new TextTileComponent());
